// extracted by mini-css-extract-plugin
module.exports = {"container":"fromFace_container__YHEqs","title":"fromFace_title__8PrSk","typeBox":"fromFace_typeBox__bZORR","cardText":"fromFace_cardText__p0EhO"};